@if (isAuthenticated === true && userNavigation && profileName){
<goab-app-header url="/" [heading]="headerTitle" [secondaryText]="secondaryText">
  <goab-block slot="utilities" direction="row" gap="0">
    @if(badgeTypeStatus && badgeContentStatus && !hideBadgeStatus){
    <div class="badgeWrapper">
      <goab-badge [type]="badgeTypeStatus" [content]="badgeContentStatus" size="large" [icon]="true"></goab-badge>
    </div>
    }

    <goab-block direction="column" gap="0">
      <goab-menu-button
        [text]="isMobile ? initials : profileName"
        [type]="userNavigation.type"
        size="compact"
        (onAction)="menuAction($event)"
      >
        @for (menuItem of userNavigation.menuItems; track menuItem.action) { @if (showMenuItem(menuItem)){
        <goab-menu-action [text]="menuItem.text" [action]="menuItem.action" [icon]="menuItem.icon"></goab-menu-action>
        } }
      </goab-menu-button>

      @if (!hidePrimaryRole && primaryRole){
      <div [class]="isMobile ? 'primaryRole mobile' : 'primaryRole'">{{ primaryRole }}</div>
      }
    </goab-block>
  </goab-block>
</goab-app-header>
} @else{
<!--If not authenticated or cannot access profile info, use default header-->
<goab-app-header url="/" [heading]="headerTitle" [secondaryText]="secondaryText">
  @if (!isAuthenticated){
  <goab-button slot="utilities" type="tertiary" size="compact" leadingIcon="person" (onClick)="login()"
    >Sign in</goab-button
  >
  }@else{
  <goab-button slot="utilities" type="tertiary" size="compact" leadingIcon="person" (onClick)="logout()"
    >Sign out</goab-button
  >
  }
</goab-app-header>
}
